export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const PJ_BACKEND_URL = process.env.REACT_APP_PJ_BACKEND_URL;
export const USER_PASSWORD = process.env.REACT_APP_USER_PASSWORD;
export const USERNAME = process.env.REACT_APP_USERNAME;
export const ADYEN_CLIENT_ID = process.env.REACT_APP_ADYEN_CLIENT_ID;
export const ADYEN_ENVIRONMENT = process.env.REACT_APP_ADYEN_ENVIRONMENT;

if (!ENVIRONMENT) {
  console.error('ENVIRONMENT not set!');
}
if (!PJ_BACKEND_URL) {
  console.error('PJ_BACKEND_URL not set!');
}
if (!USER_PASSWORD) {
  console.error('USER_PASSWORD not set!');
}
if (!USERNAME) {
  console.error('USERNAME not set!');
}
if (!ADYEN_CLIENT_ID) {
  console.error('ADYEN_CLIENT_ID not set!');
}
if (!ADYEN_ENVIRONMENT) {
  console.error('ADYEN_ENVIRONMENT not set!');
}

const validEnvValues = ['DEVELOPMENT', 'STAGING', 'PRODUCTION'];

if (!validEnvValues.includes(ENVIRONMENT)) {
  console.error(`Unexpected value ${ENVIRONMENT} for ENVIRONMENT!`);
}

export const DEFAULT_PJ_PRIMARY_COLOR = '#EE7B30';
